<template>

    <v-page-section>
        <template #title>Theme</template>
        <template #body>
            <v-form-group label="Primary Color">
                <v-input-color class="w-200" :model="params.color_primary" @input="onChangeColor('color_primary', $event)" />
            </v-form-group>
            <v-form-group label="Sidebar Color">
                <v-input-color class="w-200" :model="params.color_sidebar" @input="onChangeColor('color_sidebar', $event)" />
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" :loading="loading" @click.native="updateTheme">Save</v-button>
        </template>
    </v-page-section>

</template>

<script>

import ProjectApi from '@api/ProjectApi';
import ProjectUtil from '@utils/ProjectUtil';

export default {

    data() {
        return {
            loading: false,
            params: {},
        }
    },

    created() {
        this.params = {
            color_primary: this.project.theme.color_primary,
            color_sidebar: this.project.theme.color_sidebar,
        };
    },

    methods: {

        updateTheme() {
            this.loading = true;
            ProjectApi.updateTheme(this.project.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        onChangeColor(key, color) {
            if (color.length === 7) {
                this.params[key] = color;
                ProjectUtil.setTheme(this.params);
            }
        },

    },

}

</script>